import React from "react";
import type {FunctionComponent} from "react";
import {useWhenSongDetailsNotLoadedLogic} from "./WhenSongDetailsNotLoaded.logic";



export const WhenSongDetailsNotLoaded: FunctionComponent = ({children}) => {
  const {isConditionPassed} = useWhenSongDetailsNotLoadedLogic();
  if (!isConditionPassed) {
    return null;
  }
  return <>{children}</>;
};
